import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import {
  findPronunciationLevelIndex,
  formatPronunciationLevelLabel,
} from "@-/dev.improve.haniverse.lib.level";
import {
  getSimplifiedLevels,
  getTraditionalLevels,
} from "@-/dev.improve.haniverse.assets.graphemes.levels";
import { useActorUser } from "@-/dev.improve.haniverse.lib.user";
import { NewMorphemeLessonLayoutContext } from "@-/dev.improve.haniverse.routes.nav.app.learn.lesson.new-morpheme._context";
import { useMemo } from "react";

/** The level surface header: the lesson's level (`Level 2`, `Level 2-P1`) and this card's position. */
export function useLessonPageLevelSurfaceTexts() {
  const [grapheme, lesson, cards, lessonPart] = useContextSelectors(
    NewMorphemeLessonLayoutContext,
    (c) => c.grapheme,
    (c) => c.lesson,
    (c) => c.lessonCharacters,
    (c) => c.lessonPart,
  );
  const { hanziScript } = useActorUser();
  const pronunciationIndex = useMemo(() => {
    const levels = hanziScript === "traditional" ? getTraditionalLevels() : getSimplifiedLevels();
    return findPronunciationLevelIndex(levels, lesson) ?? 0;
  }, [hanziScript, lesson]);
  // A pronunciation-level lesson counts through its own level (`Level 2-P1`).
  const label =
    lessonPart === "pronunciation"
      ? formatPronunciationLevelLabel(lesson, pronunciationIndex)
      : String(lesson.index + 1);
  const cardNumber = Math.max(0, cards.indexOf(grapheme) + 1);
  return { description: `${cardNumber}/${cards.length} cards`, label: `Level ${label}` };
}
